import React from 'react';
import t from 'babel-plugin-yate/macro';
import {formatRON} from '../lib/misc';

export function Products({products, total, productCategories}) {
  if (!products || (products && !products.length)) {
    return [];
  }

  return (
    <>
      {products.map(({name, qty = 0, price = 0, category_id}, i) => {
        const category = productCategories?.find(
          category => category_id === category.id,
        );
        return (
          <div className="pb-4 border-b border-white" key={i}>
            {category?.name && <p className="mb-1">{category?.name}</p>}
            <p className="mb-4">{name}</p>
            <div className="flex justify-between items-center uppercase text-12">
              <div className="flex">
                <span>{t`Quantity`}</span>
                <span className="ml-4 px-2 border border-white rounded">
                  {qty}
                </span>
              </div>
              <span>{formatRON(price)}</span>
            </div>
          </div>
        );
      })}

      <div className="flex justify-between pt-2 border-t border-white">
        <span className="font-medium">{t`Total`}</span>
        <span className="font-medium">{formatRON(total)}</span>
      </div>
    </>
  );
}
